<template>
  <div class="newStore">
    <div class="form_store">
      <div style="font-weight: bold;margin-bottom: 16px">Store ID</div>
      <div>{{store_id}}</div>
      <el-form :model="StoreAddForm"
               ref="storeForm"
               label-width="100px"
               class="demo-ruleForm"
               label-position="top"
               :status-icon="true"
               :show-message="false">
        <div class="topTask">
          <el-form-item label="Store name" required prop="store_name">
            <el-input v-model="StoreAddForm.store_name" placeholder="Name" maxlength="100" @change="validateStore"></el-input>
          </el-form-item>
          <el-form-item label="Username" required prop="username">
            <el-input v-model="StoreAddForm.username" placeholder="Name" maxlength="20" @change="validateUsername"></el-input>
          </el-form-item>
          <el-form-item label="New Password" required v-if="editMes == ''" prop="password">
            <el-input v-model="StoreAddForm.password" placeholder="New Password"></el-input>
          </el-form-item>
          <el-form-item label=" Store address" required>
            <composeInput ref="store_address"></composeInput>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="footers">
      <div>
        <el-button type="success" @click="BackHandle" class="changes">Back</el-button>
        <el-button @click="confirmAddStore" class="changeCreate">Save</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import composeInput from "@/components/composeInput";
import {addStore, createStoreId, editStore} from "@/api/organization";
export default {
  name: "addNewStore",
  components:{
    composeInput
  },
  props:{
    orgInfo:{
      default:''
    },
    editMes:{
      default: {}
    }
  },
  data(){
    return{
      store_id:'',
      StoreAddForm:{
        store_name:'',
        username:'',
        password:'',
      },
      storeForm:{
        store_name: [
          { required: true, message: '', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    if (this.editMes != ''){
      this.store_id = this.editMes.suffix
      //如果editMes 不等于空的话 就是编辑 将传过来的值附给StoreAddForm
      // this.StoreAddForm ={...this.editMes}
      this.StoreAddForm.username = this.editMes.username
      this.StoreAddForm.store_name = this.editMes.store_name
      setTimeout(()=>{
        this.$refs.store_address.changeForm.address  = this.editMes.address
        this.$refs.store_address.changeForm.city = this.editMes.city
        this.$refs.store_address.changeForm.abs = this.editMes.abs
        this.$refs.store_address.changeForm.province = this.editMes.province
        this.$refs.store_address.changeForm.postcode  = this.editMes.postcode
      },100)
    }else {
      createStoreId({
        organization_id:this.orgInfo
      }).then(res=>{
        if (res.code == 200){
          this.store_id = res.data
        }
      })
    }
  },
  methods:{
    validateStore(event){
      if (event.length >99){
        this.$message({
          type:"error",
          message:"Store name must be less than 100 characters"
        })
      }
    },
    validateUsername(event){
      if (event.length > 19){
        this.$message({
          type:"error",
          message:"Username must be less than 20 characters"
        })
      }
    },
    validateForm() {
      let flag = false
      this.$refs['storeForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    BackHandle(){
      this.clearTheForm()
      this.$emit('closeAddStore')
    },
    clearTheForm(){
      this.StoreAddForm = {
          store_name:'',
            username:'',
            password:'',
      }
      this.$refs.store_address.changeForm.address = ''
      this.$refs.store_address.changeForm.city = ''
      this.$refs.store_address.changeForm.province = ''
      this.$refs.store_address.changeForm.postcode = ''
      this.$refs.store_address.changeForm.abs = ''
      this.$refs.storeForm.resetFields()
    },
    confirmAddStore(){
      console.log(this.orgInfo,'dd',this.editMes)
      this.StoreAddForm.id =this.orgInfo
      this.StoreAddForm.address = this.$refs.store_address.changeForm.address
      this.StoreAddForm.city = this.$refs.store_address.changeForm.city
      this.StoreAddForm.province = this.$refs.store_address.changeForm.province
      this.StoreAddForm.postcode = this.$refs.store_address.changeForm.postcode
      this.StoreAddForm.abs= this.$refs.store_address.changeForm.abs
      if (this.editMes == ""){
        //传过来的编辑信息 为空 说明是新增
        if (this.validateForm()){
          addStore(this.StoreAddForm).then(res=>{
            if (res.code == 200){
              this.$emit('closeAddStore')
              this.clearTheForm()
              this.$message({
                type:"success",
                message:res.msg
              })
            }else {
              this.$message({
                type:"warning",
                message:res.msg
              })
            }
          }).catch(err=>{
            this.$message({
              type:"error",
              message:err.msg
            })
          })
        }else {
          this.$message({
            type:"warning",
            message:'Some information missing'
          })
        }

      }else {
        this.StoreAddForm.id = this.editMes.id
        //否则是编辑
        editStore(this.StoreAddForm).then(res=>{
          if (res.code == 200){
            this.$emit('closeAddStore')
            this.clearTheForm()
            this.$message({
              type:"success",
              message:'Edited Successfully'
            })
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type:'error',
            message:err.msg
          })
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.newStore{
  .form_store{
    width: 500px;
    margin: 0 auto;
  }
  .footers{
    width:calc( 100% - 72px);
    z-index: 1;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    flex-direction: row-reverse;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;
    .changeCreate{
      color: #1F2D42;
    }
    .changes{
      border: 1px solid #FFFFFF!important;
    }
    .changeCreate:focus{
      border-color: #FFFFFF;
      background-color: #FFFFFF;
    }
    .changeCreate:hover{
      border-radius: 16px;
      border: 1px solid #FFFFFF;
      background: #1F2D42;
      color: #FFFFFF;
    }
  }
}

</style>
